import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'ebb-portal-dialog-activate-complete',
    templateUrl: './dialog-activate-complete.component.html',
    standalone: false
})
export class DialogActivateCompleteComponent {

  constructor(
    public dialogRef: MatDialogRef<any>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}